module.exports = __webpack_public_path__ + "static/media/hours.4361312f.svg";